
import { Component, Mixins } from 'vue-property-decorator';
import Vue from 'vue'

@Component({
    components: { }
})
export default class ToolBar extends Vue {

    mounted(){
         
    }

}
